import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-navigation",
  "use": "icon-m-navigation-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-navigation\"><path d=\"M1 8h12v12H1zm0 13h12v12H1zM14 8h12v12H14zm13 0h12v12H27zM14 21h12v12H14zm13 0h12v12H27z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol